var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControl, Grid, MenuItem, Paper, Select, Stack, Step, StepButton, Stepper, Tooltip, Typography, } from "@mui/material";
import moment from "moment";
import ModuleTable from "../../components/UtilityComponents/moduleTable";
import useFillViewportHeight from "../../hooks/useFillViewportHeight";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
import SearchField from "../../components/FormComponents/SearchField";
import TextField from "../../components/FormComponents/TextField";
import MUIDatePicker from "../../components/FormComponents/DatePicker";
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import { CustomerPortalRegistrationManagementCols } from "../../config/TableColumns";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import { colors } from "../../Themes/colors";
import { validateDate } from "../../utils/commonUtilities";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
import { getCustomerPortalDisplayName } from "../../utils/commonUtilities";
import { emailValidation, contractIdValidation, firstNameOrLastNameValidation, sanitizeNameInput, ssnNumberValidation, formatSSNInput, sinNumberValidation, formatSINInput, federalTaxIdValidation, formatFederalTaxIdInput, businessNumberValidation, formatBusinessNumberInput, postCodeValidation, phoneNumberValidation, dateOfBirthRangeValidation, DOB_MIN_AGE_YEARS, DOB_MAX_AGE_YEARS, } from "../../utils/customerPortalValidations";
var WIZARD_STEP_LABELS = ["Account Details", "Identity Verification", "Contact Details", "Set Password"];
var getIdentityFieldConfig = function (accountType, country) {
    var isCommercial = accountType === "B";
    var isCanada = country === "CAN";
    return {
        subtitle: isCommercial
            ? "Please enter the business's employer identification number"
            : "Please enter the account holder's information",
        idLabel: isCommercial ? (isCanada ? "Business Number" : "Fed Tax Number") : isCanada ? "SIN" : "SSN",
        idPlaceholder: isCommercial ? "XX-XXX1234" : isCanada ? "XXX-XXX-1234" : "XXX-XX-1234",
        showDob: !isCommercial,
        postalLabel: isCanada ? "Postal Code" : "Zip Code",
        postalPlaceholder: isCanada ? "Enter Postal Code" : "Enter Zip Code",
    };
};
var getIdentityValidator = function (accountType, country) {
    var isCommercial = accountType === "B";
    var isCanada = country === "CAN";
    if (isCommercial) {
        return isCanada
            ? { validate: businessNumberValidation, format: formatBusinessNumberInput }
            : { validate: federalTaxIdValidation, format: formatFederalTaxIdInput };
    }
    return isCanada
        ? { validate: sinNumberValidation, format: formatSINInput }
        : { validate: ssnNumberValidation, format: formatSSNInput };
};
var getPhoneExtension = function (country) {
    if (country === "CAN")
        return "+1-CA";
    return "+1";
};
var emptyStep1 = { ContractId: "", Email: "" };
var emptyStep2 = { IdentityNumber: "", DateOfBirth: "", PostalZipCode: "" };
var emptyStep3 = { FirstName: "", LastName: "", DateOfBirth: "", Phone: "" };
var emptyStep4 = { pwd: "Login@123", cnfPwd: "Login@123" };
var emptyStep4Errors = { pwd: "", cnfPwd: "" };
var RegistrationsPanel = function (_a) {
    var portalId = _a.portalId, _b = _a.brands, brands = _b === void 0 ? [] : _b, selectedPortal = _a.selectedPortal, onPortalChange = _a.onPortalChange;
    var cpPermissions = useCustomerPortalPermissions();
    var _c = useState("list"), registrationFormView = _c[0], setRegistrationFormView = _c[1];
    var _d = useState("create"), registrationMode = _d[0], setRegistrationMode = _d[1];
    var _e = useState([]), registrations = _e[0], setRegistrations = _e[1];
    var _f = useState(false), registrationsLoading = _f[0], setRegistrationsLoading = _f[1];
    var _g = useState(1), registrationsCurrentPage = _g[0], setRegistrationsCurrentPage = _g[1];
    var _h = useState(50), registrationsRecordsPerPage = _h[0], setRegistrationsRecordsPerPage = _h[1];
    var _j = useFillViewportHeight(89), tableFillRef = _j.ref, tableFillMaxHeight = _j.maxHeight;
    var _k = useState(0), registrationsTotalCount = _k[0], setRegistrationsTotalCount = _k[1];
    var _l = useState(""), registrationSearchText = _l[0], setRegistrationSearchText = _l[1];
    var _m = useState(true), showCompletedRegistrations = _m[0], setShowCompletedRegistrations = _m[1];
    var _o = useState(null), selectedRegistrationId = _o[0], setSelectedRegistrationId = _o[1];
    var _p = useState(""), registrationFailureReason = _p[0], setRegistrationFailureReason = _p[1];
    var _q = useState(false), regenerateLinkConfirmOpen = _q[0], setRegenerateLinkConfirmOpen = _q[1];
    var _r = useState(null), pendingRegenerateRegistrationId = _r[0], setPendingRegenerateRegistrationId = _r[1];
    var _s = useState(0), wizardStep = _s[0], setWizardStep = _s[1];
    var _t = useState(0), furthestStepReached = _t[0], setFurthestStepReached = _t[1];
    var _u = useState(false), isSubmittingStep1 = _u[0], setIsSubmittingStep1 = _u[1];
    var _v = useState(false), isSubmittingStep2 = _v[0], setIsSubmittingStep2 = _v[1];
    var _w = useState(false), isSubmittingStep3 = _w[0], setIsSubmittingStep3 = _w[1];
    var _x = useState(false), isSubmittingStep4 = _x[0], setIsSubmittingStep4 = _x[1];
    var _y = useState(null), accountType = _y[0], setAccountType = _y[1];
    var _z = useState(null), country = _z[0], setCountry = _z[1];
    var _0 = useState(null), registrationApiId = _0[0], setRegistrationApiId = _0[1];
    var _1 = useState(false), detailsRequired = _1[0], setDetailsRequired = _1[1];
    var _2 = useState(emptyStep1), step1 = _2[0], setStep1 = _2[1];
    var _3 = useState(emptyStep1), step1Errors = _3[0], setStep1Errors = _3[1];
    var _4 = useState(emptyStep2), step2 = _4[0], setStep2 = _4[1];
    var _5 = useState(emptyStep2), step2Errors = _5[0], setStep2Errors = _5[1];
    var _6 = useState(emptyStep3), step3 = _6[0], setStep3 = _6[1];
    var _7 = useState(emptyStep3), step3Errors = _7[0], setStep3Errors = _7[1];
    var _8 = useState(emptyStep4), step4 = _8[0], setStep4 = _8[1];
    var _9 = useState(emptyStep4Errors), step4Errors = _9[0], setStep4Errors = _9[1];
    var identityConfig = getIdentityFieldConfig(accountType, country);
    var transformRegistrationData = function (apiRows) {
        return apiRows.map(function (reg) {
            var firstName = reg.FirstName || (reg.Name ? reg.Name.split(' ')[0] : '');
            var lastName = reg.LastName || (reg.Name ? reg.Name.split(' ').slice(1).join(' ') : '');
            var portalName = "";
            if (reg.PortalId && brands.length > 0) {
                var brand = brands.find(function (b) { return Number(b.Id) === reg.PortalId; });
                portalName = brand ? getCustomerPortalDisplayName(brand.PortalName) : "";
            }
            return {
                Id: reg.Id,
                RegistrationName: (reg.Name || "".concat(firstName, " ").concat(lastName)).trim(),
                RegistrationEmail: reg.Email,
                RegistrationStatus: (reg.RegistrationStatus || reg.Status || ''),
                RegistrationCreatedOn: reg.CreatedTime,
                RegistrationLinkExpiry: reg.LinkExpiry || reg.ExpiresAt || "",
                RegistrationPortal: portalName,
                ContractId: reg.ContractId || reg.RegisteredContract || "",
                AccountType: reg.AccountType || null,
                Country: reg.Country || null,
                IdentityNumber: reg.IdentityNumber || "",
                IdentityDateOfBirth: reg.IdentityDateOfBirth || "",
                PostalZipCode: reg.PostalZipCode || "",
                FirstName: firstName,
                LastName: lastName,
                DateOfBirth: reg.DateOfBirth || "",
                Phone: reg.Phone || "",
                FailureReason: reg.FailureReason || "",
                RegistrationLink: reg.RegistrationLink || reg.Link || "",
            };
        });
    };
    var fetchRegistrations = function (page, limit) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        return __awaiter(void 0, void 0, void 0, function () {
            var allData, serverTotal, _i, brands_1, brand, response, error_1, response, transformedData, error_2, errorMessage;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setRegistrationsLoading(true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 11, 12, 13]);
                        allData = [];
                        serverTotal = null;
                        if (!(portalId === null)) return [3, 8];
                        if (brands.length === 0) {
                            setRegistrations([]);
                            setRegistrationsTotalCount(0);
                            setRegistrationsLoading(false);
                            return [2];
                        }
                        _i = 0, brands_1 = brands;
                        _d.label = 2;
                    case 2:
                        if (!(_i < brands_1.length)) return [3, 7];
                        brand = brands_1[_i];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_REGISTRATION_LIST,
                                domain: api_service.BaseDomain.Api,
                                payLoad: __assign({ page: page, limit: limit, portalId: Number(brand.Id) }, (registrationSearchText && { email: registrationSearchText })),
                                showLoader: false,
                            })];
                    case 4:
                        response = _d.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            allData.push.apply(allData, (response.data.data || []));
                            if (typeof response.data.totalCount === "number") {
                                serverTotal = (serverTotal !== null && serverTotal !== void 0 ? serverTotal : 0) + response.data.totalCount;
                            }
                        }
                        return [3, 6];
                    case 5:
                        error_1 = _d.sent();
                        console.error("Error fetching registrations for portal ".concat(brand.Id, ":"), error_1);
                        return [3, 6];
                    case 6:
                        _i++;
                        return [3, 2];
                    case 7:
                        allData.sort(function (a, b) { return (new Date(b.CreatedTime).getTime() || 0) - (new Date(a.CreatedTime).getTime() || 0); });
                        return [3, 10];
                    case 8: return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_REGISTRATION_LIST,
                            domain: api_service.BaseDomain.Api,
                            payLoad: __assign({ page: page, limit: limit, portalId: Number(portalId) }, (registrationSearchText && { email: registrationSearchText })),
                            showLoader: false,
                        })];
                    case 9:
                        response = _d.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            allData = response.data.data || [];
                            if (typeof response.data.totalCount === "number") {
                                serverTotal = response.data.totalCount;
                            }
                        }
                        else {
                            utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch registrations", constants.TOAST_TYPES.ERROR);
                        }
                        _d.label = 10;
                    case 10:
                        transformedData = transformRegistrationData(allData);
                        if (!showCompletedRegistrations) {
                            transformedData = transformedData.filter(function (reg) { var _a; return ((_a = reg.RegistrationStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "completed"; });
                        }
                        setRegistrations(transformedData);
                        setRegistrationsTotalCount(serverTotal !== null && serverTotal !== void 0 ? serverTotal : transformedData.length);
                        return [3, 13];
                    case 11:
                        error_2 = _d.sent();
                        console.error("Error fetching registrations:", error_2);
                        errorMessage = ((_c = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                            (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                            "Failed to fetch registrations";
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                        return [3, 13];
                    case 12:
                        setRegistrationsLoading(false);
                        return [7];
                    case 13: return [2];
                }
            });
        });
    };
    var resetWizard = function () {
        setWizardStep(0);
        setFurthestStepReached(0);
        setAccountType(null);
        setCountry(null);
        setRegistrationApiId(null);
        setDetailsRequired(false);
        setStep1(emptyStep1);
        setStep1Errors(emptyStep1);
        setStep2(emptyStep2);
        setStep2Errors(emptyStep2);
        setStep3(emptyStep3);
        setStep3Errors(emptyStep3);
        setStep4(emptyStep4);
        setStep4Errors(emptyStep4Errors);
        setRegistrationFailureReason("");
    };
    var handleOpenCreateRegistration = function () {
        if (!cpPermissions.registrationManagement.canCreate) {
            utility.alert("You do not have permission to create registrations", constants.TOAST_TYPES.ERROR);
            return;
        }
        resetWizard();
        setSelectedRegistrationId(null);
        setRegistrationMode("create");
        setRegistrationFormView("form");
    };
    var prefillWizardFromRow = function (row) {
        setSelectedRegistrationId(row.Id);
        setRegistrationApiId(Number(row.Id) || null);
        setAccountType(row.AccountType);
        setCountry(row.Country);
        setStep1({ ContractId: row.ContractId, Email: row.RegistrationEmail });
        setStep1Errors(emptyStep1);
        setStep2({
            IdentityNumber: row.IdentityNumber,
            DateOfBirth: row.IdentityDateOfBirth,
            PostalZipCode: row.PostalZipCode,
        });
        setStep2Errors(emptyStep2);
        setStep3({
            FirstName: row.FirstName,
            LastName: row.LastName,
            DateOfBirth: row.DateOfBirth,
            Phone: row.Phone,
        });
        setStep3Errors(emptyStep3);
        setStep4(emptyStep4);
        setStep4Errors(emptyStep4);
        setRegistrationFailureReason(row.FailureReason);
        setDetailsRequired(!!(row.FirstName || row.LastName || row.Phone));
        setWizardStep(0);
        setFurthestStepReached(detailsRequired ? 3 : 2);
    };
    var handleOpenEditRetryRegistration = function (row) {
        if (!cpPermissions.registrationManagement.canEdit) {
            utility.alert("You do not have permission to edit registrations", constants.TOAST_TYPES.ERROR);
            return;
        }
        prefillWizardFromRow(row);
        setRegistrationMode("edit");
        setRegistrationFormView("form");
    };
    var handleOpenViewRegistration = function (row) {
        prefillWizardFromRow(row);
        setRegistrationMode("view");
        setRegistrationFormView("form");
    };
    var handleBackToRegistrationsList = function () {
        setRegistrationFormView("list");
        setSelectedRegistrationId(null);
        resetWizard();
        fetchRegistrations(registrationsCurrentPage, registrationsRecordsPerPage);
    };
    var handleStepClick = function (index) {
        if (index > furthestStepReached)
            return;
        setWizardStep(index);
    };
    var isStep1FormValid = !contractIdValidation(step1.ContractId) && !emailValidation(step1.Email);
    var handleContractContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var contractIdError, emailError, response, registerData_1, step2Data_1, validator, error_3, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    contractIdError = contractIdValidation(step1.ContractId);
                    emailError = emailValidation(step1.Email);
                    setStep1Errors({ ContractId: contractIdError, Email: emailError });
                    if (contractIdError || emailError)
                        return [2];
                    if (registrationMode !== "create") {
                        setWizardStep(1);
                        setFurthestStepReached(function (prev) { return Math.max(prev, 1); });
                        return [2];
                    }
                    if (!portalId) {
                        utility.alert("Please select a portal to continue", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    setIsSubmittingStep1(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_SELF_REGISTER,
                            domain: api_service.BaseDomain.CustomerApi,
                            payLoad: { contractId: step1.ContractId, email: step1.Email, portalId: portalId, registeredBy: "admin" },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        registerData_1 = response.data.data || {};
                        if (registerData_1.id != null)
                            setRegistrationApiId(Number(registerData_1.id));
                        if (registerData_1.accountType)
                            setAccountType(registerData_1.accountType);
                        if (registerData_1.country)
                            setCountry(registerData_1.country);
                        if (registerData_1.contractId)
                            setStep1(function (prev) { return (__assign(__assign({}, prev), { ContractId: registerData_1.contractId })); });
                        step2Data_1 = {};
                        if (registerData_1.ssn) {
                            validator = getIdentityValidator(registerData_1.accountType, registerData_1.country);
                            step2Data_1.IdentityNumber = validator.format(registerData_1.ssn);
                        }
                        if (registerData_1.dob)
                            step2Data_1.DateOfBirth = registerData_1.dob;
                        if (registerData_1.postalCode)
                            step2Data_1.PostalZipCode = registerData_1.postalCode;
                        if (Object.keys(step2Data_1).length > 0) {
                            setStep2(function (prev) { return (__assign(__assign({}, prev), step2Data_1)); });
                        }
                        setWizardStep(1);
                        setFurthestStepReached(function (prev) { return Math.max(prev, 1); });
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Could not start registration for this contract", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_3 = _d.sent();
                    console.error("Error starting registration:", error_3);
                    errorMessage = ((_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                        "Failed to start registration";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    setIsSubmittingStep1(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var isDobRequiredForContactStep = accountType !== "B";
    var isStep2FormValid = !!accountType &&
        !!country &&
        !getIdentityValidator(accountType, country).validate(step2.IdentityNumber) &&
        (identityConfig.showDob
            ? !dateOfBirthRangeValidation(step2.DateOfBirth)
            : !postCodeValidation(step2.PostalZipCode));
    var isStep3FormValid = !firstNameOrLastNameValidation(step3.FirstName, "First Name") &&
        !firstNameOrLastNameValidation(step3.LastName, "Last Name") &&
        !phoneNumberValidation(step3.Phone) &&
        (!isDobRequiredForContactStep || !dateOfBirthRangeValidation(step3.DateOfBirth));
    var isStep4FormValid = !!step4.pwd &&
        step4.pwd.length >= 8 &&
        !!step4.cnfPwd &&
        step4.pwd === step4.cnfPwd;
    var handleIdentityContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var accountTypeError, countryError, identityNumberError, dobError, postalError, payload, response, securityData_1, requiresDetails, error_4, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    accountTypeError = accountType ? "" : "Please select Account Type";
                    countryError = country ? "" : "Please select Country";
                    identityNumberError = getIdentityValidator(accountType, country).validate(step2.IdentityNumber);
                    dobError = "";
                    postalError = "";
                    if (identityConfig.showDob) {
                        dobError = dateOfBirthRangeValidation(step2.DateOfBirth);
                    }
                    else {
                        postalError = postCodeValidation(step2.PostalZipCode);
                    }
                    setStep2Errors({ IdentityNumber: identityNumberError, DateOfBirth: dobError, PostalZipCode: postalError });
                    if (accountTypeError || countryError) {
                        utility.alert(accountTypeError || countryError, constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (identityNumberError || dobError || postalError)
                        return [2];
                    if (registrationMode !== "create") {
                        if (identityConfig.showDob && !step3.DateOfBirth) {
                            setStep3(function (prev) { return (__assign(__assign({}, prev), { DateOfBirth: step2.DateOfBirth })); });
                        }
                        setWizardStep(2);
                        setFurthestStepReached(function (prev) { return Math.max(prev, 2); });
                        return [2];
                    }
                    setIsSubmittingStep2(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    payload = {
                        ssn: step2.IdentityNumber.replace(/\D/g, ""),
                        portalId: portalId,
                        id: registrationApiId,
                    };
                    if (identityConfig.showDob) {
                        payload.dob = step2.DateOfBirth;
                    }
                    else {
                        payload.postalCode = step2.PostalZipCode;
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_SELF_REGISTER_SECURITY_QUESTIONS,
                            domain: api_service.BaseDomain.CustomerApi,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        securityData_1 = response.data.data || {};
                        requiresDetails = securityData_1.details === true;
                        setDetailsRequired(requiresDetails);
                        if (requiresDetails) {
                            setStep3(function (prev) { return ({
                                FirstName: prev.FirstName || securityData_1.fname || "",
                                LastName: prev.LastName || securityData_1.lname || "",
                                Phone: prev.Phone || securityData_1.phonenumber || "",
                                DateOfBirth: prev.DateOfBirth || securityData_1.dateofbirth || "",
                            }); });
                            setWizardStep(2);
                            setFurthestStepReached(function (prev) { return Math.max(prev, 2); });
                        }
                        else {
                            setWizardStep(3);
                            setFurthestStepReached(function (prev) { return Math.max(prev, 3); });
                        }
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Could not verify identity details", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_4 = _d.sent();
                    console.error("Error verifying identity:", error_4);
                    errorMessage = ((_c = (_b = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) ||
                        "Failed to verify identity details";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    setIsSubmittingStep2(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var validateContactStep = function () {
        var firstNameError = firstNameOrLastNameValidation(step3.FirstName, "First Name");
        var lastNameError = firstNameOrLastNameValidation(step3.LastName, "Last Name");
        var dobError = isDobRequiredForContactStep ? dateOfBirthRangeValidation(step3.DateOfBirth) : "";
        var phoneError = phoneNumberValidation(step3.Phone);
        setStep3Errors({
            FirstName: firstNameError,
            LastName: lastNameError,
            DateOfBirth: dobError,
            Phone: phoneError,
        });
        return !firstNameError && !lastNameError && !dobError && !phoneError;
    };
    var handleVerifyContactDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_5, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!validateContactStep())
                        return [2];
                    setIsSubmittingStep3(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    payload = {
                        id: registrationApiId,
                        firstName: step3.FirstName,
                        lastName: step3.LastName,
                        phoneNumber: step3.Phone,
                        phoneExtension: getPhoneExtension(country),
                    };
                    if (isDobRequiredForContactStep) {
                        payload.dateOfBirth = step3.DateOfBirth;
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_SELF_REGISTER_VERIFY_DETAILS,
                            domain: api_service.BaseDomain.CustomerApi,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        setWizardStep(3);
                        setFurthestStepReached(function (prev) { return Math.max(prev, 3); });
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Could not verify contact details", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_5 = _d.sent();
                    console.error("Error verifying contact details:", error_5);
                    errorMessage = ((_c = (_b = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_5 === null || error_5 === void 0 ? void 0 : error_5.message) ||
                        "Failed to verify contact details";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    setIsSubmittingStep3(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var validatePasswordStep = function () {
        var passwordError = !step4.pwd ? "Password is required" : step4.pwd.length < 8 ? "Password must be at least 8 characters" : "";
        var confirmError = !step4.cnfPwd ? "Please confirm your password" : step4.pwd !== step4.cnfPwd ? "Passwords do not match" : "";
        setStep4Errors({ pwd: passwordError, cnfPwd: confirmError });
        return !passwordError && !confirmError;
    };
    var handleSetPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_6, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!validatePasswordStep())
                        return [2];
                    setIsSubmittingStep4(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_SELF_REGISTER_SET_PASSWORD,
                            domain: api_service.BaseDomain.CustomerApi,
                            payLoad: { id: registrationApiId, password: step4.pwd },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert("Admin Registration completed successfully!", constants.TOAST_TYPES.INFO);
                        handleBackToRegistrationsList();
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to set password", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_6 = _d.sent();
                    console.error("Error setting password:", error_6);
                    errorMessage = ((_c = (_b = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_6 === null || error_6 === void 0 ? void 0 : error_6.message) ||
                        "Failed to set password";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    setIsSubmittingStep4(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var handleCopyLink = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!row.RegistrationLink) {
                        utility.alert("No link available to copy", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, navigator.clipboard.writeText(row.RegistrationLink)];
                case 2:
                    _a.sent();
                    utility.alert("Link copied to clipboard!", constants.TOAST_TYPES.INFO);
                    return [3, 4];
                case 3:
                    error_7 = _a.sent();
                    utility.alert("Failed to copy link", constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var sendResendLinkRequest = function (registrationId) { return __awaiter(void 0, void 0, void 0, function () {
        var endpoint, expiryDate, response, error_8, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    endpoint = "".concat(api_urls.CUSTOMER_PORTAL_REGISTRATION_RESEND_LINK, "/").concat(registrationId, "/resend");
                    expiryDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
                    return [4, api_service.post({
                            endPoint: endpoint,
                            domain: api_service.BaseDomain.Api,
                            payLoad: {
                                linkExpiresAt: expiryDate,
                            },
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Registration link sent!", constants.TOAST_TYPES.INFO);
                        fetchRegistrations(registrationsCurrentPage, registrationsRecordsPerPage);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to resend link", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_8 = _d.sent();
                    console.error("Error resending registration link:", error_8);
                    errorMessage = ((_c = (_b = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_8 === null || error_8 === void 0 ? void 0 : error_8.message) ||
                        "Failed to resend link";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleResendLinkRequest = function (row) {
        if (row.RegistrationLink) {
            setPendingRegenerateRegistrationId(row.Id);
            setRegenerateLinkConfirmOpen(true);
        }
        else {
            sendResendLinkRequest(row.Id);
        }
    };
    var handleConfirmRegenerateLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingRegenerateRegistrationId)
                        return [2];
                    return [4, sendResendLinkRequest(pendingRegenerateRegistrationId)];
                case 1:
                    _a.sent();
                    setRegenerateLinkConfirmOpen(false);
                    setPendingRegenerateRegistrationId(null);
                    return [2];
            }
        });
    }); };
    var handleCancelRegenerateLink = function () {
        setRegenerateLinkConfirmOpen(false);
        setPendingRegenerateRegistrationId(null);
    };
    var registrationActionHandler = function (rowData, actionType) {
        if (actionType === "EditRetry") {
            handleOpenEditRetryRegistration(rowData);
        }
        else if (actionType === "ResendLink") {
            handleResendLinkRequest(rowData);
        }
        else if (actionType === "CopyLink") {
            handleCopyLink(rowData);
        }
        else if (actionType === "ViewDetails") {
            handleOpenViewRegistration(rowData);
        }
    };
    useEffect(function () {
        if (accountType !== "B")
            return;
        setStep3(function (prev) { return (prev.DateOfBirth ? __assign(__assign({}, prev), { DateOfBirth: "" }) : prev); });
        setStep3Errors(function (prev) { return (prev.DateOfBirth ? __assign(__assign({}, prev), { DateOfBirth: "" }) : prev); });
    }, [accountType]);
    useEffect(function () {
        if (registrationFormView === "list" && portalId !== undefined) {
            fetchRegistrations(registrationsCurrentPage, registrationsRecordsPerPage);
        }
    }, [registrationsCurrentPage, registrationsRecordsPerPage]);
    useEffect(function () {
        if (registrationFormView !== "list")
            return;
        var timer = setTimeout(function () {
            setRegistrationsCurrentPage(1);
            fetchRegistrations(1, registrationsRecordsPerPage);
        }, 500);
        return function () { return clearTimeout(timer); };
    }, [registrationSearchText]);
    useEffect(function () {
        if (registrationFormView !== "list" || portalId === undefined)
            return;
        setRegistrationsCurrentPage(1);
        fetchRegistrations(1, registrationsRecordsPerPage);
    }, [showCompletedRegistrations]);
    useEffect(function () {
        if (registrationFormView !== "list")
            return;
        setRegistrationsCurrentPage(1);
        fetchRegistrations(1, registrationsRecordsPerPage);
    }, [portalId, brands.length]);
    var dobMinDate = moment().subtract(DOB_MAX_AGE_YEARS, "years");
    var dobMaxDate = moment().subtract(DOB_MIN_AGE_YEARS, "years");
    var isViewMode = registrationMode === "view";
    var isFirstStep = wizardStep === 0;
    var isLastStep = wizardStep === 3;
    var dateChangeHandlerFor = function (setter, field, errorSetter) { return function (date) {
        errorSetter === null || errorSetter === void 0 ? void 0 : errorSetter(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = "", _a)));
        });
        if (date == null || date === "") {
            setter(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[field] = "", _a)));
            });
            return;
        }
        var dateValidation = validateDate(date);
        if (!dateValidation.isValid) {
            return;
        }
        var parsed = moment(date);
        if (parsed.isBefore(dobMinDate, "day") || parsed.isAfter(dobMaxDate, "day")) {
            return;
        }
        var formattedDate = moment(date).format("YYYY-MM-DD");
        setter(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = formattedDate, _a)));
        });
    }; };
    var formTitle = registrationMode === "create"
        ? "Create Registration"
        : registrationMode === "edit"
            ? "Edit & Retry Registration"
            : "Registration Details";
    return (React.createElement(React.Fragment, null,
        registrationFormView === "list" ? (React.createElement(Paper, { elevation: 0, sx: { p: { xs: 2, sm: 3 }, borderRadius: 2, border: "1px solid ".concat(colors.greyShades[20]), bgcolor: colors.fullWhite } },
            React.createElement(Stack, { direction: { xs: "column", md: "column", lg: "row" }, justifyContent: "space-between", alignItems: { xs: "stretch", lg: "center" }, mb: 2, gap: 2 },
                React.createElement(Stack, { direction: { xs: "column", sm: "row" }, gap: 2, sx: { width: "100%" } },
                    React.createElement(Box, { sx: { flex: { xs: 1, sm: "0 0 200px" } } },
                        React.createElement(FormControl, { fullWidth: true, size: "small" },
                            React.createElement(Select, { fullWidth: true, size: "small", value: selectedPortal !== null && selectedPortal !== void 0 ? selectedPortal : "", onChange: function (event) {
                                    var value = event.target.value;
                                    onPortalChange === null || onPortalChange === void 0 ? void 0 : onPortalChange(value === "" ? null : Number(value));
                                }, displayEmpty: true, sx: { minHeight: 40, bgcolor: colors.fullWhite } },
                                React.createElement(MenuItem, { value: "" }, "All portals"),
                                brands.map(function (brand) { return (React.createElement(MenuItem, { key: brand.Id, value: Number(brand.Id) }, getCustomerPortalDisplayName(brand.PortalName))); })))),
                    React.createElement(Box, { sx: { flex: 1, minWidth: { xs: "100%", sm: 200 } } },
                        React.createElement(SearchField, { value: registrationSearchText, onSearch: setRegistrationSearchText, placeholder: "Search by Name/Email", debounceTimer: 500 }))),
                React.createElement(Stack, { direction: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" }, gap: 2, sx: { width: { xs: "100%", lg: "auto" } } },
                    React.createElement(Stack, { direction: "row", alignItems: "center" },
                        React.createElement(Checkbox, { checked: showCompletedRegistrations, onChange: function (e) { return setShowCompletedRegistrations(e.target.checked); } }),
                        React.createElement(Typography, { variant: "body2" }, "Show Completed")),
                    cpPermissions.registrationManagement.canCreate && (React.createElement(Tooltip, { title: selectedPortal === null ? "Select a portal to create a registration" : "" },
                        React.createElement(Box, { sx: { width: { xs: "100%", sm: "auto" } } },
                            React.createElement(Button, { variant: "contained", onClick: handleOpenCreateRegistration, disabled: selectedPortal === null, sx: { textTransform: "none", whiteSpace: "nowrap", width: "100%" } }, "Create Registration")))))),
            React.createElement(Box, { ref: tableFillRef },
                React.createElement(ModuleTable, { dataToDisplay: registrations, columns: CustomerPortalRegistrationManagementCols, isLoading: registrationsLoading, actionHandler: registrationActionHandler, moduleName: "Customer Portal Registration Management", isPortalSelected: true, hideEditIcon: true, useCustomerPortalMenu: true, activePage: registrationsCurrentPage, recordsPerPage: registrationsRecordsPerPage, setActivePage: setRegistrationsCurrentPage, setRecordsPerPage: setRegistrationsRecordsPerPage, totalNumberOfRecords: registrationsTotalCount, customerPoratl: true, tableContainerMaxHeight: tableFillMaxHeight, hidePagination: true })),
            React.createElement(Box, { sx: { mt: 1.5, flexShrink: 0 } },
                React.createElement(CommonTablePagination, { tableData: registrations, currentPage: registrationsCurrentPage, perPageCount: registrationsRecordsPerPage, setCurrentPage: setRegistrationsCurrentPage, setPerPageCount: setRegistrationsRecordsPerPage, totalNumberOfRecords: registrationsTotalCount })))) : (React.createElement(Paper, { elevation: 0, sx: { p: { xs: 2, sm: 3, md: 4 }, borderRadius: 2, border: "1px solid ".concat(colors.greyShades[20]), bgcolor: colors.fullWhite } },
            React.createElement(Typography, { fontWeight: 600, fontSize: { xs: 16, sm: 18 }, sx: { mb: 3 } }, formTitle),
            React.createElement(Stepper, { nonLinear: true, activeStep: wizardStep, sx: { mb: 4, maxWidth: 700, mx: "auto", overflow: { xs: "auto", sm: "visible" }, "& .MuiStepLabel-label": { fontSize: { xs: "0.75rem", sm: "0.875rem" } } } }, WIZARD_STEP_LABELS.map(function (label, index) {
                if (index === 2 && !detailsRequired)
                    return null;
                return (React.createElement(Step, { key: label, completed: index < furthestStepReached },
                    React.createElement(StepButton, { onClick: function () { return handleStepClick(index); }, disabled: index > furthestStepReached }, label)));
            })),
            React.createElement(Box, { sx: { maxWidth: 560, mx: "auto", px: { xs: 1, sm: 0 } } },
                wizardStep === 0 && (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Contract ID", name: "ContractId", isMandatoryField: true, placeholder: "Contract ID", fullWidth: true, value: step1.ContractId, onChange: function (e) {
                                setStep1(function (prev) { return (__assign(__assign({}, prev), { ContractId: e.target.value })); });
                                setStep1Errors(function (prev) { return (__assign(__assign({}, prev), { ContractId: "" })); });
                            }, type: "text", disabled: registrationMode !== "create", error: !!step1Errors.ContractId, error_message: step1Errors.ContractId })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Email", name: "Email", isMandatoryField: true, placeholder: "john.smith@sample.com", fullWidth: true, value: step1.Email, onChange: function (e) {
                                setStep1(function (prev) { return (__assign(__assign({}, prev), { Email: e.target.value })); });
                                setStep1Errors(function (prev) { return (__assign(__assign({}, prev), { Email: "" })); });
                            }, type: "text", disabled: registrationMode !== "create", error: !!step1Errors.Email, error_message: step1Errors.Email })))),
                wizardStep === 1 && (React.createElement(Box, null,
                    React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 } }, identityConfig.subtitle),
                    React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: identityConfig.idLabel, name: "IdentityNumber", isMandatoryField: true, placeholder: identityConfig.idPlaceholder, fullWidth: true, value: step2.IdentityNumber, onChange: function (e) {
                                    var formatted = getIdentityValidator(accountType, country).format(e.target.value);
                                    setStep2(function (prev) { return (__assign(__assign({}, prev), { IdentityNumber: formatted })); });
                                    setStep2Errors(function (prev) { return (__assign(__assign({}, prev), { IdentityNumber: "" })); });
                                }, type: "text", disabled: isViewMode, error: !!step2Errors.IdentityNumber, error_message: step2Errors.IdentityNumber })),
                        React.createElement(Grid, { item: true, xs: 12, sx: { "& .MuiStack-root": { p: 0 } } }, identityConfig.showDob ? (React.createElement(MUIDatePicker, { labelText: "Date of Birth", isMandatory: true, selectedDate: step2.DateOfBirth, dateChangeHandler: dateChangeHandlerFor(setStep2, "DateOfBirth", setStep2Errors), disabled: isViewMode, errorMessage: step2Errors.DateOfBirth, minDate: dobMinDate, maxDate: dobMaxDate, disableManualInput: true })) : (React.createElement(TextField, { label: identityConfig.postalLabel, name: "PostalZipCode", isMandatoryField: true, placeholder: identityConfig.postalPlaceholder, fullWidth: true, value: step2.PostalZipCode, onChange: function (e) {
                                setStep2(function (prev) { return (__assign(__assign({}, prev), { PostalZipCode: e.target.value })); });
                                setStep2Errors(function (prev) { return (__assign(__assign({}, prev), { PostalZipCode: "" })); });
                            }, type: "text", disabled: isViewMode, error: !!step2Errors.PostalZipCode, error_message: step2Errors.PostalZipCode })))))),
                wizardStep === 2 && detailsRequired && (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(TextField, { label: "First Name", name: "FirstName", isMandatoryField: true, placeholder: "First Name", fullWidth: true, value: step3.FirstName, onChange: function (e) {
                                var val = sanitizeNameInput(e.target.value);
                                setStep3(function (prev) { return (__assign(__assign({}, prev), { FirstName: val })); });
                                setStep3Errors(function (prev) { return (__assign(__assign({}, prev), { FirstName: "" })); });
                            }, type: "text", disabled: isViewMode, error: !!step3Errors.FirstName, error_message: step3Errors.FirstName })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(TextField, { label: "Last Name", name: "LastName", isMandatoryField: true, placeholder: "Last Name", fullWidth: true, value: step3.LastName, onChange: function (e) {
                                var val = sanitizeNameInput(e.target.value);
                                setStep3(function (prev) { return (__assign(__assign({}, prev), { LastName: val })); });
                                setStep3Errors(function (prev) { return (__assign(__assign({}, prev), { LastName: "" })); });
                            }, type: "text", disabled: isViewMode, error: !!step3Errors.LastName, error_message: step3Errors.LastName })),
                    isDobRequiredForContactStep && (React.createElement(Grid, { item: true, xs: 12, sx: { "& .MuiStack-root": { p: 0 } } },
                        React.createElement(MUIDatePicker, { labelText: "Date of Birth", isMandatory: true, selectedDate: step3.DateOfBirth, dateChangeHandler: dateChangeHandlerFor(setStep3, "DateOfBirth", setStep3Errors), disabled: isViewMode, errorMessage: step3Errors.DateOfBirth, minDate: dobMinDate, maxDate: dobMaxDate, disableManualInput: true }))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Cell Phone Number", name: "Phone", isMandatoryField: true, placeholder: "Phone Number", fullWidth: true, value: step3.Phone, onChange: function (e) {
                                setStep3(function (prev) { return (__assign(__assign({}, prev), { Phone: e.target.value })); });
                                setStep3Errors(function (prev) { return (__assign(__assign({}, prev), { Phone: "" })); });
                            }, type: "text", disabled: isViewMode, maxLength: 10, startAdornment: country === "CAN" ? "🇨🇦 +1" : "🇺🇸 +1", error: !!step3Errors.Phone, error_message: step3Errors.Phone })),
                    registrationMode === "edit" && registrationFailureReason ? (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Box, { sx: {
                                p: 1.5,
                                borderRadius: 1,
                                bgcolor: "#FEECEC",
                                border: "1px solid #F7C5C2",
                            } },
                            React.createElement(Typography, { variant: "body2", sx: { color: "#B42318", fontWeight: 600 } }, "Last attempt failed"),
                            React.createElement(Typography, { variant: "body2", sx: { color: "#B42318" } }, registrationFailureReason)))) : null)),
                wizardStep === 3 && (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Password", name: "Password", isMandatoryField: true, placeholder: "Enter password (minimum 8 characters)", fullWidth: true, value: step4.pwd, onChange: function (e) {
                                setStep4(function (prev) { return (__assign(__assign({}, prev), { Password: e.target.value })); });
                                setStep4Errors(function (prev) { return (__assign(__assign({}, prev), { Password: "" })); });
                            }, type: "password", disabled: isViewMode, error: !!step4Errors.pwd, error_message: step4Errors.pwd })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Confirm Password", name: "ConfirmPassword", isMandatoryField: true, placeholder: "Confirm your password", fullWidth: true, value: step4.cnfPwd, onChange: function (e) {
                                setStep4(function (prev) { return (__assign(__assign({}, prev), { ConfirmPassword: e.target.value })); });
                                setStep4Errors(function (prev) { return (__assign(__assign({}, prev), { ConfirmPassword: "" })); });
                            }, type: "password", disabled: isViewMode, error: !!step4Errors.cnfPwd, error_message: step4Errors.cnfPwd }))))),
            React.createElement(Stack, { direction: { xs: "column-reverse", sm: "row" }, justifyContent: "space-between", alignItems: { xs: "stretch", sm: "center" }, sx: { mt: 4, pt: 2, gap: { xs: 2, sm: 0 }, borderTop: "1px solid ".concat(colors.greyShades[20]) } },
                React.createElement(Button, { variant: "outlined", onClick: function () {
                        if (isFirstStep) {
                            handleBackToRegistrationsList();
                        }
                        else if (wizardStep === 3 && !detailsRequired) {
                            setWizardStep(1);
                        }
                        else {
                            setWizardStep(function (s) { return s - 1; });
                        }
                    }, sx: { width: { xs: "100%", sm: "auto" } } }, isFirstStep ? "Cancel" : "Back"),
                isViewMode ? (React.createElement(Button, { variant: "contained", onClick: isLastStep ? handleBackToRegistrationsList : function () { return setWizardStep(function (s) { return s + 1; }); }, sx: { width: { xs: "100%", sm: "auto" } } }, isLastStep ? "Close" : "Next")) : (React.createElement(Button, { variant: "contained", disabled: (isFirstStep && registrationMode === "create" && (!isStep1FormValid || isSubmittingStep1)) ||
                        (wizardStep === 1 && (!isStep2FormValid || isSubmittingStep2)) ||
                        (wizardStep === 2 && (!isStep3FormValid || isSubmittingStep3)) ||
                        (isLastStep && (!isStep4FormValid || isSubmittingStep4)), onClick: isFirstStep
                        ? handleContractContinue
                        : wizardStep === 1
                            ? handleIdentityContinue
                            : wizardStep === 2
                                ? handleVerifyContactDetails
                                : handleSetPassword, sx: { width: { xs: "100%", sm: "auto" } } }, (isFirstStep && isSubmittingStep1) || (wizardStep === 1 && isSubmittingStep2) || (wizardStep === 2 && isSubmittingStep3) || (isLastStep && isSubmittingStep4)
                    ? "Submitting..."
                    : isLastStep
                        ? "Create Account"
                        : "Continue"))))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Regenerate registration link?", message: "This will invalidate the previous link. Continue?", acceptBtnText: "Yes", denyBtnText: "No", open: regenerateLinkConfirmOpen, acceptCallBack: handleConfirmRegenerateLink, denyCallBack: handleCancelRegenerateLink, cancelCallBack: handleCancelRegenerateLink, swapButtonOrder: true })));
};
export default RegistrationsPanel;
